import { useRef, useState, useEffect } from 'react';
import { ButtonProps } from '@m/alchemy-ui/Button';

import * as Styled from './DiamondShapeButton.styled';

function deg2rad(degrees: number): number {
  return (degrees * Math.PI) / 180;
}

export function DiamondShapeButton({
  size,
  children,
  className,
  ...buttonProps
}: DiamondShapeButtonProps) {
  const btnRef = useRef<HTMLButtonElement>(null);
  const [btnSize, setBtnSize] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (btnRef.current && !btnSize) {
      const { clientWidth, clientHeight } = btnRef.current;
      const currentBtnSize = Math.max(clientWidth, clientHeight);

      // 45 degrees as the square button is composed of two right triangles.
      setBtnSize(Math.sin(deg2rad(45)) * (size || currentBtnSize));
    }
  }, [btnRef, btnSize, size]);

  const containerSize = btnSize ? btnSize / Math.sin(deg2rad(45)) : undefined;

  return (
    <Styled.Container style={{ height: containerSize }}>
      <Styled.Button
        className={className}
        {...buttonProps}
        ref={btnRef}
        style={{ width: btnSize, height: btnSize }}
      >
        <Styled.ButtonContent>{children}</Styled.ButtonContent>
      </Styled.Button>
    </Styled.Container>
  );
}

type DiamondShapeButtonProps = Omit<ButtonProps, 'size'> & {
  size?: number;
  className?: string;
  children?: JSX.Element | JSX.Element[];
};
